import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "title": "Доступ",
  "lead": "Во всем мире 88 % детей получают начальное образование, 78 % подростков получают неполное среднее и 59 % молодежи – полное среднее образование."
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    blockquote: "blockquote",
    h2: "h2",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {Figure, Highlight, HighlightByIndex, IndicatorReference, PageLink, RelatedMaterial, ScrollyArea, ScrollySection, ScrollySticky, Tooltip} = _components;
  if (!Figure) _missingMdxReference("Figure", true);
  if (!Highlight) _missingMdxReference("Highlight", true);
  if (!HighlightByIndex) _missingMdxReference("HighlightByIndex", true);
  if (!IndicatorReference) _missingMdxReference("IndicatorReference", true);
  if (!PageLink) _missingMdxReference("PageLink", true);
  if (!RelatedMaterial) _missingMdxReference("RelatedMaterial", true);
  if (!ScrollyArea) _missingMdxReference("ScrollyArea", true);
  if (!ScrollySection) _missingMdxReference("ScrollySection", true);
  if (!ScrollySticky) _missingMdxReference("ScrollySticky", true);
  if (!Tooltip) _missingMdxReference("Tooltip", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Figure, {
      id: "HERO_ACCESS"
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "Мир не выполнил своего обязательства о предоставлении каждому ребёнку к 2015 году возможности пойти в начальную школу. Новая цель в области образования, ЦУР 4, устанавливала обеспечить молодежи получение среднего образования к 2030 году, таким образом подняв планку амбиций на ступеньку выше. Для реализации этой цели все дети, достигшие начального школьного возраста, должны были пойти в школу в 2018 году, но в реальности, например, в странах с низким уровнем дохода это сделали только 70 % детей."
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "посещаемость-дошкольных-учреждений",
      children: "Посещаемость дошкольных учреждений"
    }), "\n", _jsx(IndicatorReference, {
      id: "4.2.2",
      children: _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Посещение дошкольного учреждения"
        }), " является важной отправной точкой на пути детей к получению образования. Однако в странах с низким уровнем дохода только 44 % детей посещают дошкольные учреждения за год до поступления в начальную школу."]
      })
    }), "\n", _jsx(_components.p, {
      children: "С 2000 года в большинстве стран, в том числе во многих беднейших странах, наблюдается медленный, но устойчивый прогресс в посещаемости дошкольных учреждений, однако многие страны по-прежнему отстают. В настоящее время 75 % детей во всем мире посещают дошкольные учреждения по сравнению с 64 % в 2003 году."
    }), "\n", _jsx(_components.p, {
      children: "В некоторых странах наблюдается значительный рост. В Кыргызстане, например, уровень посещения дошкольных учреждений увеличился с 42 % в 2000 году до 87 % в 2024 году. В Лаосской Народно-Демократической Республике этот показатель за тот же период увеличился с 10 % до 89 %."
    }), "\n", _jsxs(_components.p, {
      children: ["Согласно приведенным ниже показателям, ", _jsx(HighlightByIndex, {
        index: "0",
        children: "Гватемала"
      }), " и ", _jsx(HighlightByIndex, {
        index: "1",
        children: "Нигер"
      }), " – примеры стран, в которых наблюдается устойчивый рост посещаемости дошкольных учреждений, хотя сегодня между этими показателями существуют огромные разрывы. Выберите свою страну, чтобы увидеть ее прогресс."]
    }), "\n", _jsx(Figure, {
      id: "PREPRIM"
    }), "\n", _jsx(_components.h2, {
      id: "посещаемость-школ-детьми-старше-установленного-возраста",
      children: "Посещаемость школ детьми старше установленного возраста"
    }), "\n", _jsx(IndicatorReference, {
      id: "4.1.5",
      children: _jsxs(_components.p, {
        children: ["Мы недостаточно говорим о том, что в ряде стран возраст более четверти учащихся начальной школы на момент поступления ", _jsx(_components.strong, {
          children: "старше"
        }), " возраста, установленного для учеников их класса. Это имеет серьезные последствия для их будущего, увеличивая вероятность дальнейшего повторения учебного года, провала экзаменов и, в конечном итоге, прекращения обучения в школе."]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["На графике представлено ", _jsx(_components.strong, {
        children: "участие в образовании"
      }), ", т. е. возраст, в котором дети, подростки и молодежь получают дошкольное, начальное, неполное и полное среднее, а также послешкольное образование. Цветом показано то, сколько детей посещают школу в более старшем возрасте. Серая область показывает процент детей и подростков, которые не посещают школу с разбивкой по возрасту."]
    }), "\n", _jsxs(ScrollyArea, {
      children: [_jsx(ScrollySticky, {
        children: _jsx(Figure, {
          id: "OVERAGE"
        })
      }), _jsx(ScrollySection, {
        id: "KHM",
        children: _jsxs(_components.p, {
          children: ["В ", _jsx(Highlight, {
            children: "Камбодже"
          }), " большинство детей должны посещать школу в возрасте 10\nлет, однако 21 % детей все еще не посещают школу в этом возрасте. Многие дети старше возраста, установленного\nдля их класса. Например, некоторые 14-летние дети все еще посещают начальную\nшколу."]
        })
      }), _jsx(ScrollySection, {
        id: "LBR",
        children: _jsxs(_components.p, {
          children: ["Доля детей, посещающих школу старше установленного возраста, выше в таких странах, как", " ", "\n", _jsx(Highlight, {
            children: "Либерия"
          }), ", где 28 % 10-летних детей посещают дошкольные образовательные учреждения, и\n20 % 18-летних людей все еще учатся в начальной школе."]
        })
      }), _jsx(ScrollySection, {
        id: "NPL",
        children: _jsxs(_components.p, {
          children: [_jsx(Highlight, {
            children: "Непал"
          }), " сталкивается с той же проблемой,"]
        })
      }), _jsx(ScrollySection, {
        id: "MWI"
      })]
    }), "\n", _jsx(_components.h2, {
      id: "дети-не-посещающие-школу",
      children: "Дети, не посещающие школу"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.1.4",
      children: [_jsxs(_components.p, {
        children: ["Во всем мире ", _jsx(_components.a, {
          href: "https://www.education-estimates.org",
          children: "272 миллион"
        }), " детей и подростков ", _jsx(_components.strong, {
          children: "не посещают школу"
        }), "."]
      }), _jsx(_components.p, {
        children: "Конфликты — ключевая причина застоя. К сожалению, конфликт также означает, что доступность и качество данных ухудшаются, хотя некоторые страны продолжают предоставлять оценочные данные. С целью правильно оценить недавнеее влияние COVID-19 на поступление в учебные заведения также требуется полная и устойчивая информация."
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "OOSRATE"
          })
        }), _jsx(ScrollySection, {
          id: "ECU,PRY",
          children: _jsxs(_components.p, {
            children: [_jsx(Highlight, {
              children: "Эквадор"
            }), " и ", _jsx(Highlight, {
              children: "Парагвай"
            }), " показывают очень\nразные направления прогресса. В младших и старших классах средней школы\nдоля детей, не посещающих школу, в Эквадоре резко упала, в то время как она выросла в\nПарагвае."]
          })
        }), _jsx(ScrollySection, {
          id: "ERI,ETH",
          children: _jsxs(_components.p, {
            children: [_jsx(Highlight, {
              children: "Эритрея"
            }), " и ", _jsx(Highlight, {
              children: "Эфиопия"
            }), " также показывают\nочень разные темпы прогресса. Последствия конфликта в Эритрее\nзаметно отразились на доступе к образованию, в то время как Эфиопия уделяет приоритетное внимание\nобразованию в своем бюджете, что привело к быстрому сокращению количества детей, не посещающих\nшколу, за короткий период времени."]
          })
        })]
      })]
    }), "\n", _jsx(_components.p, {
      children: "Еще одной причиной отсутствия прогресса в сокращении числа детей, не посещающих школу, является рост населения."
    }), "\n", _jsxs(_components.p, {
      children: ["В странах Африки к югу от Сахары ", _jsx(HighlightByIndex, {
        index: "2",
        children: "численность населения начального школьного возраста"
      }), " почти удвоилась в период с 2000 по 2023 год. В результате этого, несмотря на то что ", _jsx(HighlightByIndex, {
        index: "0",
        children: "доля детей, не посещающих школу"
      }), ", за этот период сократилась почти вдвое, ", _jsx(HighlightByIndex, {
        index: "1",
        children: "фактическое количество детей, не посещающих школу,"
      }), " практически не изменилось."]
    }), "\n", _jsx(Figure, {
      id: "OOSREL"
    }), "\n", _jsx(_components.h2, {
      id: "получение-образования",
      children: "Получение образования"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.1.2",
      children: [_jsxs(_components.p, {
        children: ["Конечной целью ЦУР 4 является всеобщее ", _jsx(_components.strong, {
          children: "получение"
        }), " полного среднего образования, а не только зачисление в старшие классы средней школы. И это несмотря на то, что во многих странах образование является бесплатным и обязательным только до уровня неполного среднего образования."]
      }), _jsx(_components.p, {
        children: "Мир не движется к достижению всеобщего начального образования к установленному сроку, не говоря уже о полном среднем образовании. При сохранении текущих тенденций в 2030 году примерно шесть из десяти молодых людей закончат среднюю школу."
      }), _jsxs(_components.p, {
        children: ["Этот показатель относится к детям, которые могут получить образование на 3 или 5 лет позже официального возраста окончания — ", _jsx(Tooltip, {
          title: "Своевременное завершение",
          content: "Дети, которые заканчивают образование на 3 или 5 лет позже официального возраста окончания школы",
          children: "своевременное завершение"
        }), ". Однако многие дети заканчивают обучение даже позже — ", _jsx(Tooltip, {
          title: "Окончательное завершение",
          content: "Дети, которые заканчивают образование позже официального возраста окончания школы на срок до 8 лет",
          children: "окончательное завершение"
        }), "."]
      }), _jsxs(_components.p, {
        children: ["Если взглянуть на график ниже, то, например, в Мозамбике существует почти 20-процентный разрыв между ", _jsx(HighlightByIndex, {
          index: "0",
          children: "своевременным"
        }), " (49%) и ", _jsx(HighlightByIndex, {
          index: "1",
          children: "окончательным"
        }), " завершением (66%) на уровне начальной школы."]
      }), _jsx(Figure, {
        id: "COMPLETION"
      })]
    }), "\n", _jsx(_components.h2, {
      id: "заключение",
      children: "Заключение"
    }), "\n", _jsx(_components.p, {
      children: "Важнейшими вопросами политики являются возраст поступления детей в школу, возраст завершения обучения и получение полного среднего образования."
    }), "\n", _jsxs(_components.p, {
      children: ["В следующих темах на этом сайте рассматривается путь к достижению ", _jsx(PageLink, {
        name: "equity",
        children: "равенства"
      }), " в образовании, ", _jsx(PageLink, {
        name: "learning",
        children: "образовательные программы"
      }), " для учащихся, ", _jsx(PageLink, {
        name: "quality",
        children: "качество"
      }), "их образования и кто его ", _jsx(PageLink, {
        name: "finance",
        children: "финансирует"
      }), "."]
    }), "\n", _jsx(RelatedMaterial, {
      children: _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://www.education-estimates.org",
            children: "Visualizing Indicators of Education for the World (VIEW)"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://unesdoc.unesco.org/ark:/48223/pf0000382577",
            children: "Новая оценка подтверждает, что в странах Африки к югу от Сахары растет количество людей, не посещающих школу"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://resourcecentre.savethechildren.net/library/education-against-odds-meeting-marginalised-childrens-demands-quality-education",
            children: "Образование превыше всего — Save the Children"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "http://uis.unesco.org/sites/default/files/documents/ip61-combining-data-out-of-school-children-completion-learning-offer-more-comprehensive-view-sdg4.pdf",
            children: "Объединение данных о детях, не посещающих школу, получении образования и обучении с целью более полного представления о прогрессе в достижении ЦУР 4"
          })
        }), "\n"]
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
